import { ChainId } from '@pulsex/chains'
import { PublicClient, createPublicClient, http } from 'viem'
import { pulsechain } from 'wagmi/chains'
import { CHAINS } from 'config/chains'
import { getRpcUrls } from 'config/rpc'
import { fallbackWithRank } from './fallbackWithRank'

export function createViemPublicClients() {
  return CHAINS.reduce((prev, cur) => {
    return {
      ...prev,
      [cur.id]: createPublicClient({
        chain: cur,
        // No fetchOptions.signal: it would override viem's per-request timeout.
        transport: fallbackWithRank(getRpcUrls(cur.id).map((url) => http(url, { timeout: 4_000 }))),
        batch: {
          multicall: {
            batchSize: 1024 * 25,
            wait: 16,
          },
        },
        pollingInterval: 6_000,
      }),
    }
  }, {} as Record<ChainId, PublicClient>)
}

export const viemClients = createViemPublicClients()

export const getViemClients = createViemPublicClientGetter({ viemClients })

type CreateViemPublicClientGetterParams = {
  viemClients?: Record<ChainId, PublicClient>
}

export function createViemPublicClientGetter({
  viemClients: viemClientsOverride,
}: CreateViemPublicClientGetterParams = {}) {
  const clients = viemClientsOverride || createViemPublicClients()

  return function getClients({ chainId }: { chainId?: ChainId }): PublicClient {
    return clients[chainId as ChainId]
  }
}

const PUBLIC_MAINNET = 'https://rpc.pulsechain.com'

export const CLIENT_CONFIG = {
  batch: {
    multicall: {
      batchSize: 1024 * 200,
      wait: 16,
    },
  },
  pollingInterval: 6_000,
}

export const publicClient = ({ chainId }: { chainId?: ChainId }) => {
  if (chainId && viemClients[chainId]) {
    return viemClients[chainId]
  }
  let httpString: string | undefined

  if (process.env.NODE_ENV === 'test' && chainId === pulsechain.id) {
    httpString = PUBLIC_MAINNET
  }

  const chain = CHAINS.find((c) => c.id === chainId)

  return createPublicClient({ chain, transport: http(httpString), ...CLIENT_CONFIG })
}
